import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseHttpService } from './base-http.service';
import { environment } from '../../../environments/environment';
import { UserFamilyStatus } from '../../shared/helpers/app.constants';
import { IResultModel } from '../../shared/models/common.model';
import { IUserFamilyDto } from '../../shared/models/user-family.model';

@Injectable({
  providedIn: 'root'
})
export class UserFamilyService extends BaseHttpService {

  apiBaseUrl = environment.apiBaseUrl;

  constructor() {
    super();
  }

  getMyFamily(): Observable<IUserFamilyDto[]> {
    return this.http.get<IUserFamilyDto[]>(`${this.apiBaseUrl}UserFamily/MyFamily`);
  }

  invite(email: string): Observable<IResultModel<string>> {
    return this.http.post<IResultModel<string>>(`${this.apiBaseUrl}UserFamily/Invite`, email);
  }

  changeStatus(status: UserFamilyStatus, memberId: string): Observable<IResultModel<string>> {
    const params: string[] = [];
    params.push(`status=${status}`);
    if (memberId) {
      params.push(`memberId=${memberId}`);
    }
    const queryString = params.join('&');
    return this.http.post<IResultModel<string>>(`${this.apiBaseUrl}UserFamily/ChangeStatus?${queryString}`, {});
  }
}